import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';

import ModalHeader from '@common-components/headers/ModalHeader';

export const AccessCodeErrorModal = props => {

    const {
        modalHeaderProps,
        actions: {
            hideModal
        }
    } = props;

    const handleCloseModal = () => hideModal();

    return (
        <Fragment>
            <ModalHeader {...modalHeaderProps }/>
            <div id="accessCodeErrorModal" className="grid-container">
                <div className="gi-modal__body">
                    <p>
                        <FormattedMessage id="further_action.modal.warning_msg"/>
                    </p>
                </div>
            </div>
            <div className="gi-modal__footer">
                <div className='grid-row controls'>
                    <div className='text-center'>
                        <button onClick={handleCloseModal}
                            className="ds-c-button ds-c-button--primary ds-u-margin--1">
                            <FormattedMessage id="dashboard.ok"/>
                        </button>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};


